import {
  Component,
  OnInit,
  OnDestroy,
  PLATFORM_ID,
  inject,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Subscription } from 'rxjs';
import { TenantService, TenantInfo } from '../shared/services/tenant.service';

@Component({
  selector: 'black-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.css'],
  standalone: false,
})
export class TermsComponent implements OnInit, OnDestroy {
  private tenantService = inject(TenantService);
  private platformId = inject(PLATFORM_ID);

  private sub?: Subscription;

  currentTenant: TenantInfo | null = null;
  mode: 'default' | 'link' | 'custom' = 'default';
  externalUrl?: string;
  customContent?: string;
  lastUpdated?: string | Date;

  ngOnInit(): void {
    this.sub = this.tenantService.currentTenant$.subscribe((tenant) => {
      this.currentTenant = tenant;
      const policies = tenant?.settings?.policies;
      this.mode = policies?.termsMode || 'default';
      this.externalUrl = policies?.termsUrl;
      this.customContent = policies?.termsContent;
      this.lastUpdated = policies?.termsUpdatedAt;

      if (this.mode === 'link' && this.externalUrl) {
        if (isPlatformBrowser(this.platformId)) {
          window.location.replace(this.externalUrl);
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  get academyName(): string {
    return this.currentTenant?.name || 'Learnbird';
  }

  get contactEmail(): string {
    return (
      this.currentTenant?.settings?.legal?.contactEmail ||
      'contact@learnbird.lk'
    );
  }
}
